import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import Button from '@paradigm/design-system/src/components/Button';

export default styled(Button).attrs({
  theme: 'quick-action',
  size: 'extra-small',
})`
  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 1rem;
    border-radius: 1rem;
  }
`;
